<!--显示APP订单-->
<template>
  <el-dialog :title="title" :visible.sync="dialogSeeVisible"  center :close-on-click-modal="false" :append-to-body="true" :destroy-on-close="true" custom-class="medium-dialog">
    <el-radio-group v-model="activeName" @change="bingImg">
      <el-radio-button label="first" v-if="!hidOrder">订单详情</el-radio-button>
      <el-radio-button label="second" v-if="glassesform.length > 0">验光数据</el-radio-button>
      <el-radio-button label="oldmirrordegree" v-if="checkExist('oldmirrordegree')">旧镜度数</el-radio-button>
      <el-radio-button label="biometric" v-if="checkExist('biometric')">生物测量</el-radio-button>
      <el-radio-button label="funduscamera" v-if="checkExist('funduscamera')">眼底照相</el-radio-button>
      <el-radio-button label="slitlamp" v-if="checkExist('slitlamp')">裂隙灯</el-radio-button>
      <el-radio-button label="computeroptometry" v-if="checkExist('computeroptometry')">电脑验光</el-radio-button>
      <el-radio-button label="positivereview" v-if="orderDetail.positivereview==1">好评</el-radio-button>
    </el-radio-group>
    <el-form  ref="form1">
    <el-collapse v-model="collapseNames" v-if="activeName!='first'">
      <el-collapse-item v-if="activeName=='second'" name="1">
        <template slot="title">
            <span class="titlecolor">处方单</span>
        </template>
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="顾客：" :label-width="formLabelWidth" class="el-form-item">
              {{glasses.uname}}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="验光师：" :label-width="formLabelWidth">
              {{glasses.adduname}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="验光日期：" :label-width="formLabelWidth">
              {{glasses.adddate}}
            </el-form-item>
          </el-col>
        </el-row>
        <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
               class="query-table">
          <tr>
            <td style="text-align: center;width: 50px">R/L</td>
            <td style="text-align: center;min-width: 80px">球镜</td>
            <td style="text-align: center;min-width: 80px">柱镜</td>
            <td style="text-align: center;min-width: 80px">轴位</td>
            <td style="text-align: center;min-width: 80px">矫正视力</td>
            <td style="text-align: center;min-width: 80px">原镜视力</td>
            <td style="text-align: center;min-width: 80px">裸眼视力</td>
            <td style="text-align: center;min-width: 80px">棱镜</td>
            <td style="text-align: center;min-width: 80px">基底</td>
            <td style="text-align: center;min-width: 80px">ADD</td>
            <td style="text-align: center;min-width: 80px">通道</td>
          </tr>
          <tr>
            <td>R</td>
            <td>{{getPlus(R.Y)}}</td>
            <td>{{getPlus(R.X)}}</td>
            <td>{{R.A}}</td>
            <td>{{R['矫正视力']}}</td>
            <td>{{R['原镜视力']}}</td>
            <td>{{R['裸眼视力']}}</td>
            <td>{{R['棱镜']}}</td>
            <td>{{R['基底']}}</td>
            <td>{{R['ADD']}}</td>
            <td>{{R['通道']}}</td>
          </tr>
          <tr>
            <td>L</td>
            <td>{{getPlus(L.Y)}}</td>
            <td>{{getPlus(L.X)}}</td>
            <td>{{L.A}}</td>
            <td>{{L['矫正视力']}}</td>
            <td>{{L['原镜视力']}}</td>
            <td>{{L['裸眼视力']}}</td>
            <td>{{L['棱镜']}}</td>
            <td>{{L['基底']}}</td>
            <td>{{L['ADD']}}</td>
            <td>{{L['通道']}}</td>
          </tr>
        </table>
        <el-row :gutter="24" >
          <el-col :span="4" v-for="item in ShareChild1" :key="item">
            <el-form-item :label="item+'：'"  :label-width="formLabelWidth" class="el-form-item">
              {{Share[item]}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" v-if="Share['备注']">
          <el-col :span="24">
            <el-form-item label="备注：" :label-width="formLabelWidth" class="el-form-item">
              {{Share['备注']}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-collapse-item>
      <el-collapse-item v-if="activeName=='second'" name="2">
        <template slot="title">
          <span class="titlecolor">视功能参数</span>
        </template>
        <el-row :gutter="24" >
          <el-col :span="6" v-for="item in ShareChild2"  :key="item">
            <el-form-item :label="item+'：'"  :label-width="formLabelWidth" class="el-form-item">
              {{Share[item]}}
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="Flipper："  :label-width="formLabelWidth" class="el-form-item">
             {{Share['OD']?('OD '+Share['OD']):''}} {{Share['OS']?('  OS '+Share['OS']):''}} {{Share['OU']?('  OU '+Share['OU']):''}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-collapse-item>
      <el-collapse-item v-if="activeName=='second'" name="3">
        <template slot="title">
          <span class="titlecolor">镜架参数</span>
        </template>
        <el-row :gutter="24" >
          <el-col :span="6" v-for="item in ShareChild3"  :key="item">
            <el-form-item :label="item+'：'"  :label-width="formLabelWidth" class="el-form-item">
              {{Share[item]}}
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="Share['近用阅读距离']">
            <el-form-item label="近用阅读距离"  :label-width="formLabelWidth" class="el-form-item">
              {{Share['近用阅读距离']}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-collapse-item>
      <el-collapse-item v-if="activeName=='oldmirrordegree'" name="3">
        <template slot="title">
          <span class="titlecolor">旧镜度数</span>
        </template>
        <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
               class="query-table">
          <tr>
            <td style="text-align: center;width: 50px">R/L</td>
            <td style="text-align: center;width: 80px">球镜</td>
            <td style="text-align: center;width: 80px">柱镜</td>
            <td style="text-align: center;width: 80px">轴位</td>
            <td style="text-align: center;width: 80px">瞳距</td>
          </tr>
          <tr v-if="oldmirrordegree.r">
            <td>R</td>
            <td>{{getPlus(oldmirrordegree.r.y)}}</td>
            <td>{{getPlus(oldmirrordegree.r.x)}}</td>
            <td>{{oldmirrordegree.r.a}}</td>
            <td>{{oldmirrordegree.r['瞳距']}}</td>
          </tr>
          <tr v-if="oldmirrordegree.l">
            <td>L</td>
            <td>{{getPlus(oldmirrordegree.l.y)}}</td>
            <td>{{getPlus(oldmirrordegree.l.x)}}</td>
            <td>{{oldmirrordegree.l.a}}</td>
            <td>{{oldmirrordegree.l['瞳距']}}</td>
          </tr>
        </table>
      </el-collapse-item>
      <el-collapse-item v-if="activeName=='biometric'&&biometric" name="3">
        <template slot="title">
          <span class="titlecolor">生物测量</span>
        </template>
        <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
               class="query-table">
          <tr>
            <td style="text-align: center;width: 50px">R/L</td>
            <td style="text-align: center;width: 80px">眼轴⻓度 AL</td>
            <td style="text-align: center;width: 80px">中央⻆膜厚度 CCT</td>
            <td style="text-align: center;width: 80px">前房深度 AD</td>
            <td style="text-align: center;width: 80px">晶体厚度 LT</td>
            <td style="text-align: center;width: 80px">玻璃体厚度 VT</td>
          </tr>
          <tr>
            <td>R</td>
            <td>{{biometric.RAL}}</td>
            <td>{{biometric.RCCT}}</td>
            <td>{{biometric.RAD}}</td>
            <td>{{biometric.RLT}}</td>
            <td>{{biometric.RVT}}</td>
          </tr>
          <tr>
            <td>R</td>
            <td>{{biometric.LAL}}</td>
            <td>{{biometric.LCCT}}</td>
            <td>{{biometric.LAD}}</td>
            <td>{{biometric.LLT}}</td>
            <td>{{biometric.LVT}}</td>
          </tr>
        </table>
      </el-collapse-item>
      <el-collapse-item v-if="activeName=='biometric'&&biometric" name="4">
        <template slot="title">
          <span class="titlecolor">曲率</span>
        </template>
        <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
               class="query-table">
          <tr>
            <td style="text-align: center;width: 50px">R/L</td>
            <td style="text-align: center;width: 80px">曲率@轴位 K1</td>
            <td style="text-align: center;width: 80px">曲率@轴位 K2</td>
            <td style="text-align: center;width: 80px">散光@轴位 AST</td>
            <td style="text-align: center;width: 80px">瞳孔直径 Pupil</td>
            <td style="text-align: center;width: 80px">⽩对⽩ WTW</td>
          </tr>
          <tr>
            <td>R</td>
            <td>{{biometric.RK1}}D@ {{biometric.RA1}}°</td>
            <td>{{biometric.RK2}}D@ {{biometric.RA2}}°</td>
            <td>{{getNumber(biometric.RAST)}}D@ {{biometric.RASTA}}°</td>
            <td>{{biometric.RPupil}}</td>
            <td>{{biometric.RWTW}}</td>
          </tr>
          <tr>
            <td>R</td>
            <td>{{biometric.LK1}}D@ {{biometric.LA1}}°</td>
            <td>{{biometric.LK2}}D@ {{biometric.LA2}}°</td>
            <td>{{getNumber(biometric.LAST)}}D@ {{biometric.LASTA}}°</td>
            <td>{{biometric.LPupil}}</td>
            <td>{{biometric.LWTW}}</td>
          </tr>
        </table>
      </el-collapse-item>
      <el-collapse-item v-if="activeName=='funduscamera'&&reprtURL" name="3">
        <template slot="title">
          <span class="titlecolor">报告详情</span>
        </template>
        <iframe :src="reprtURL" class="framestyle" frameborder="0" scrolling="auto" name="showairdocframe"></iframe>
      </el-collapse-item>
      <el-collapse-item name="4">
        <template slot="title">
          <span class="titlecolor">照片</span>
        </template>
        <el-image :src="item.url" alt="" v-for="item in fileList" :key="item.url" @click="openUrl(item.url)"></el-image>
      </el-collapse-item>
    </el-collapse>
    </el-form>
    <iframe :src="iframeurl" ref="frameprint"  v-if="activeName=='first'" class="framestyle" frameborder="0" scrolling="auto" name="showsellframe"></iframe>
    <!--<div slot="footer" class="dialog-footer no-print">-->
      <!--<el-button type="info" @click="print1()"  size="mini">打印</el-button>-->
    <!--</div>-->
  </el-dialog>
</template>

<script>
  import {orderView} from '@/api/order/shopping';
  import {sellDetail,otherformList,getfunduscamera,getAirdocReport} from '@/api/order/jxcglassesell';
  import {getListData} from '@/api/attachment'

  export default {
    name: 'showGlassessell',
    data() {
      return {
        activeName: 'first',
        collapseNames: ['1', '2', '3', '4', '5', '6', '7'],
        title: '',
        iframeurl: "",
        glasses: {},
        R: {},
        L: {},
        reprtURL:'',
        Share: {},
        ShareChild1: ['主视眼', '总瞳距', '右瞳距', '左瞳距', '远用近用'],
        ShareChild2: ['Worth4dot', '立体视', '远眼位', 'NRA', 'PRA', '近眼位', 'BCC', 'AC/A', 'AMP', 'NPC'],
        ShareChild3: ['框型', '镜宽', '梁宽', '镜高', '倾斜角', '镜面角', '面弯', '镜眼距', '最大对较长', '右眼瞳高', '左眼瞳高', '镜片直径'],
        oldmirrordegree:{},
        biometric:{},
        dialogSeeVisible: false,
        orderDetail: {},
        glassesform: {},
        otherform: [],
        fileList:[],
        formLabelWidth: '100px'
      }
    },
    props:{
      hidOrder:false
    },
    methods: {
      print1() {
        const iframe = this.$refs.frameprint;
        // const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

        iframe.contentWindow.print();
      },
      checkExist(componentpath) {
        for (let i in this.otherform) {
          if (this.otherform[i].componentpath == componentpath) {
            return this.otherform[i];
          }
        }
        return null;
      },
      getPlus(data) {
        if (data && data.indexOf('-') == -1) {
          return '+' + data;
        }
        return data;
      },
      getNumber(data) {
        if (!data) return '';
        return parseFloat(data).toFixed(2);
      },
      bindAttach(groupGuid, groupType) {
        var data = {
          groupGuid: groupGuid,
          groupType: groupType
        };
        this.fileList = []
        getListData(data).then((result) => {
          for (let i in result.data.obj) {
            this.fileList.push({
              "name": result.data.obj[i]["filename"],
              "url": result.data.obj[i]["virtualpath"],
              "size": result.data.obj[i]["filesize"]
            })
          }
        })
      },
      openUrl(url) {
        window.open(url, "");
      },
      bingImg() {
        if (this.activeName == 'first')
          return;
        if (this.activeName == 'second') {
          this.bindAttach(this.glasses.unitguid, 'yanguang');
        } else if (this.activeName == 'positivereview') {
          this.bindAttach(this.orderDetail.unitguid, 'positivereview');
        } else {
          var row = this.checkExist(this.activeName);
          if (this.activeName == 'oldmirrordegree') {
            this.oldmirrordegree = JSON.parse(row.formcontent);
          }else if(this.activeName=='biometric') {
            this.biometric = null;
            if (row.formcontent) {
              try {
                var formcontent1 = JSON.parse(row.formcontent);
                this.biometric = formcontent1.ClinicResult[0];
              } catch (ex) {
              }
            }
          } else if (this.activeName == 'funduscamera' && !this.reprtURL) {
            getfunduscamera({cusmobile: this.orderDetail.mobile, customerguid: row.parentuguid}).then(resp => {
              var fun = resp.data.obj;
              if (fun && fun.length > 0 && fun[0].screencode) {
                getAirdocReport({screencode: fun[0].screencode, isbasic: fun[0].isbasic}).then(
                  airdoc => {
                    try {
                      this.reprtURL = airdoc.data['综合分析报告'].data.url;
                    } catch (ex) {

                    }
                  }
                );
              }
            });
          }
          this.bindAttach(row.parentuguid, this.activeName);
        }
      },
      show(row) {
        if (!row.groupguid) return;
        this.dialogSeeVisible = true;
        this.iframeurl = orderView(row);
        this.reprtURL = '';
        this.R = {};
        this.L = {};
        this.Share = {};
        this.glasses = {};
        this.oldmirrordegree = {};
        this.activeName = this.hidOrder ? 'second' : 'first';
        this.otherform = [];
        sellDetail({unitguid: row.groupguid}).then(response => {
          this.orderDetail = response.data.obj;
          this.glassesform = response.data.glasses;
          if (this.glassesform && this.glassesform.length > 0) {
            if (row.showyg && row.showyg == 1) {
              this.activeName = 'second';
            }
            this.glasses = this.glassesform[0];
            this.R = JSON.parse(this.glasses.r);
            this.L = JSON.parse(this.glasses.l);
            this.Share = JSON.parse(this.glasses.share);
            otherformList({parentuguid: this.glasses.unitguid}).then(resForm => {
              this.otherform = resForm.data.obj;
            });
          }
        });
      },
    },
    mounted() {

    },
    components: {
    }
  }
</script>

<style scoped>
  .framestyle {
    width: 100%;
    border: 0px;
    height: calc(100vh - 260px);
    background-size: 100% 100%;
    margin: 0px;
    padding: 0px;
  }
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }
  .el-form-item {
    margin-bottom: 2px !important;
  }
</style>





// WEBPACK FOOTER //
// src/components/testorder/cstagreement/showGlassessell.vue